export default __webpack_public_path__ + "static/media/tumbleweed_night.467ab6fb.svg";